import { CssPropertyType } from '@wix/ambassador-devcenter-components-v1-component/types';
import { GlobalDesignAction } from '../types';
import { groupByGroupDefinitions } from '../common/grouping/defaultGroupingStrategy';
import { MergingStrategyConfig } from '../common/grouping/types';
import defaultValueMergingStrategy from '../common/grouping/defaultValueMergingStrategy';

export const fillGrouping: GlobalDesignAction<'fillStyles'>['grouping'] = {
  getGroupingStrategy: (editorPointer, getHost) => {
    return () => {
      return groupByGroupDefinitions(editorPointer, 'fillStyles', getHost);
    };
  },

  applyValueMergingStrategy: (stylesGroups) => {
    const config: MergingStrategyConfig<'fillStyles'> = {
      allowSubsets: true,
      valueComparator: {
        [CssPropertyType.background]: (value1, value2) =>
          value1?.type === value2?.type && value1?.color === value2?.color,
        [CssPropertyType.backgroundColor]: (value1, value2) =>
          value1?.type === value2?.type && value1?.color === value2?.color,
        [CssPropertyType.backgroundImage]: (value1, value2) =>
          value1?.type === value2?.type && value1?.image === value2?.image,
      },
    };

    return defaultValueMergingStrategy<'fillStyles'>(stylesGroups, config);
  },
};
